import { FormTemplate } from 'data/template/template.types';

export const i18nKeyPrefix = 'targetOptions.form';

export type TargetOption = {
  LOC_POLL_FREQ?: string
};

export type Ref = {
  isValid: (forceValidation: boolean, forceTouched: boolean) => boolean
  getValues: () => TargetOption
}

export const targetOptionsTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Target Options',
  key: 'TargetOptions',
  main: {
    metadata: {
      layout: {
        rows: [
          [
            'LOC_POLL_FREQ',
          ],
        ],
      },
    },
    fields: {
      LOC_POLL_FREQ: {
        label: 'Pull location updates frequency from AMF (sec)',
        type: 'text',
        hintMessage: 'Updates will only be pulled when value is greater than 0.',
        initial: '0',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 8,
            },
            {
              type: 'customFunction',
              customValidationFunction: 'invalidLocPollFreqValueValidator',
              errorMessage: 'Must be 0 (i.e. don\'t do location pull), or between 30 - 99999999 (in 30-second increments). Please re-enter.',
            },
          ],
        },
      },
    },
  },
};

export const targetDomainTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Target Domain',
  key: 'targetDomain',
  main: {
    metadata: {
      layout: {
        rows: [
          ['SIP_DOMAIN'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      SIP_DOMAIN: {
        label: 'Domain',
        type: 'advancedSelect',
        initial: '',
        allowCreate: true,
        options: [{
          label: 'None',
          value: 'Tk9ORQ',
        }],
        validation: {
          required: false,
          validators: [
            {
              type: 'length',
              length: 32,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
    },
  },
};

export const targetOptionsVolteTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Volte Target Options',
  key: 'volteTargetOptions',
  main: {
    metadata: {
      layout: {
        rows: [
          ['tid'],
          ['coid'],
          ['WARRANT_HOSTS'],
        ],
      },
    },
    fields: {
      tid: {
        type: 'text',
        initial: '',
        hide: 'true'
      },
      coid: {
        type: 'text',
        initial: '',
        hide: 'true'
      },
      WARRANT_HOSTS: {
        type: 'text',
        label: 'Warrant Hosts',
        initial: '',
      },
    },
  },
};
